<template>
  <div class="login">
    <div class="login__bg">
      <div class="box"></div>
    </div>
    <el-row
      type="flex"
      justify="end"
    >
      <el-col
        :span="12"
        class="login__form__box"
      >
        <div class="login__form__left">
          <div class="login__form__left__top">
            <!-- <p class="title">Hello !</p> -->
            <p class="title2">
              <span class>欢迎登录系统</span>
            </p>
          </div>
          <el-form
            class="login__form__left__main"
            :model="loginForm"
            :rules="rules"
            ref="loginForm"
          >
            <el-form-item prop="username">
              <el-input
                type="input"
                v-model="loginForm.username"
                autocomplete="off"
                placeholder="请输入账户"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                autocomplete="off"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <!-- <el-row :gutter="22">
              <el-col :span="12">
                <el-form-item prop="code">
                  <el-input
                    v-model="loginForm.code"
                    placeholder="请输入验证码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div
                  class="coderight"
                  @click="identifyCode = makeCode()"
                >
                  <Identify :identifyCode="identifyCode" />
                </div>
              </el-col>
            </el-row> -->
            <el-form-item>
              <button
                class="login__form__left__button"
                type="primary"
                @click.prevent="login()"
              >登 录</button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <div class="tips">
      <span>版权所有 ICP证：</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备13042057号</a>
    </div>
    <EditPsw :visible.sync="editVisible" @onSuccess="login" />
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import EditPsw from '@/components/EditPsw/index.vue';


export default {
  components: { EditPsw },
  props: {},
  data() {
    return {
      editVisible:false,
      identifyCode: this.makeCode(),
      loginForm: {
        username: "",
        password: "",
        code: ""
      },
      rules: {
        username: [
          {
            required: true,
            message: "账户不能为空!",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空!",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            trigger: "blur",
            message: "验证码不能为空"
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) =>
              value.toLocaleLowerCase() ===
              this.identifyCode.toLocaleLowerCase()
                ? callback()
                : callback(new Error("请输入正确的验证码"))
          }
        ]
      }
    };
  },

  methods: {
    ...mapMutations(["COMMIT_USER"]),
    ...mapActions(["DISPATCH_CLEARCHACE"]),
    async login(psw) {
      try {
        await this.$refs.loginForm.validate();
        const { username, password } = this.loginForm;
        const { data } = await this.$API.login({
          username,
          password:psw ? psw : password
        });
        await this.DISPATCH_CLEARCHACE({ Vue: this });
        this.COMMIT_USER(data);
        if(data.passwordModifiedFlag === 1){
          this.$msgBox.confirm('当前账号密码为初始密码先修改密码后，才能进入平台！', '提示', {
            confirmButtonText: '立即修改',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              this.editVisible = true;
          }).catch(() => {});
        }else{
          this.$router.push("/");
        }

      } catch (error) {
        console.error(error);
        this.identifyCode = this.makeCode();
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确的字段",
          type: "error"
        });
      }
    },
    makeCode() {
      const codes = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(
        ""
      );
      return new Array(4)
        .fill("")
        .map(() => {
          const i = randomNum(0, codes.length);
          return codes[i];
        })
        .join("");

      function randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__bg {
    flex: 1;
    position: fixed;
    display: flex;
    align-items: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 1000px;
    z-index: -10;
    zoom: 1;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    background-image: url("../../assets/img/login/bg.png");
  }
  .login__form__box {
    border-radius: 20px;
    box-shadow: 0 0 2px 2px #EFF4F6;
  }
  &__form {
    border-radius: 20px;

    &__box {
      width: 364px;
      height: 460px;
      overflow: hidden;
      margin-right: 156px;
      margin-top: 20px;
    }
    &__left {
      padding: 40px;
      background-color: transparent;
      filter: blur(0.3px);
      &__top {
        font-family: Microsoft YaHei;
        font-weight: Regular;
        line-height: 44px;
        padding-bottom: 60px;
        .title {
          font-size: 2em;
          color: #333333;
        }
        .title2 {
          font-size: 35px;
          color: #999999;
          text-align: center;
          span {
            color: #fff;
            font-weight: 900;
            font-style: italic;
            letter-spacing: 6px;
          }
        }
      }
      &__main {
        ::v-deep .el-input__inner {
          border-radius: 0;
          border: none;
          border-bottom: 1px solid #00d3b8;
        }
        ::v-deep .el-input__inner:-webkit-autofill {
          box-shadow: 0 0 0 1000px white inset !important;
        }
        ::v-deep .el-form-item.is-error .el-input__inner {
          border-color: #d3d3d3;
        }
        // ::v-deep .el-form-item__error {
        //   color: green
        // }
      }
      &__button {
        width: 100%;
        height: 44px;
        background: linear-gradient(to right, #4B98E6, #519DE8);
        border-radius: 6px;
        border: 0px;
        font-size: 20px;
        font-family: Arial;
        color: rgba(255, 255, 255, 1);
        line-height: 44px;
        user-select: none;
        outline: 0;
        cursor: pointer;
        margin-top: 30px;
        &:hover {
          box-shadow: 0px 0px 2px 0px #009f8b;
        }
      }
    }
  }
  .tips{
    position: absolute;
    bottom: 30px;
    text-align: center;
    color: #fff;
    width: 100%;
    >a{
      text-decoration: none;
      color: #0595fe;
    }
  }
}
</style>
